import { z } from "zod";

export const emptyResponseSchema = z.object({});
export const createConfidenceVoteSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
});
export const endConfidenceVoteSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
});
export const joinConfidenceVoteSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
});
export const getParticipantsResponseSchema = z.object({
  participants: z.array(
    z.object({
      userId: z.string(),
      name: z.string(),
      email: z.string().optional(),
      imageUrl: z.string().optional(),
      color: z.string().optional(),
      hasVoted: z.boolean(),
      vote: z
        .object({
          confidenceLevel: z.enum([
            "no_confidence",
            "very_low",
            "low",
            "medium",
            "high",
            "very_high",
          ]),
          createdAt: z.string().datetime({ offset: true }),
        })
        .optional(),
    }),
  ),
  totalCount: z.number().int(),
  totalVotes: z.number().int(),
  isAnonymous: z.boolean(),
});
export const getConfidenceVoteSessionsResponseSchema = z.object({
  sessions: z.array(
    z.object({
      id: z.string(),
      piSessionId: z.string(),
      createdByUserId: z.string(),
      title: z.string(),
      description: z.string().optional(),
      status: z.enum(["draft", "active", "ended"]),
      endedAt: z.string().datetime({ offset: true }).optional(),
      createdAt: z.string().datetime({ offset: true }),
      participatingTeamIds: z.array(z.string()),
      isAnonymousVote: z.boolean(),
      totalParticipants: z.number().int().optional(),
      totalVotes: z.number().int().optional(),
      voteBreakdown: z
        .object({
          veryHigh: z.number().int(),
          high: z.number().int(),
          medium: z.number().int(),
          low: z.number().int(),
          veryLow: z.number().int(),
          noConfidence: z.number().int(),
        })
        .optional(),
      averageScore: z.number().optional(),
    }),
  ),
});
export const getMyVoteResponseSchema = z.object({
  vote: z
    .object({
      confidenceLevel: z.enum(["no_confidence", "very_low", "low", "medium", "high", "very_high"]),
      createdAt: z.string().datetime({ offset: true }),
    })
    .optional(),
});
export const updateConfidenceVoteSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
});
export const startConfidenceVoteSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
});
